export default __webpack_public_path__ + "static/media/Ntorq125_Posterior.a05a0e1b.webp";